import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
   {
    path: '',
    title: 'Configuracion',
    moduleName: 'configuracion',
    icon: 'settings',
    class: 'menu-toggle',
    groupTitle: false,
    submenu: [
      {
        path: '/dashboard/config',
        title: 'Ajustes del Sistema',
        moduleName: 'configuracion',
        icon: 'tool',
        class: '',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/usuario/list-usuario',
        title: 'Usuarios',
        moduleName: 'usuario',
        icon: 'users',
        class: 'ml-menu',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/categoria',
        title: 'Categorias',
        moduleName: 'categoria',
        icon: 'box',
        class: 'ml-menu',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/cargos',
        title: 'Cargos',
        moduleName: 'cargos',
        icon: 'box',
        class: 'ml-menu',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/ambientes',
        title: 'Ambientes',
        moduleName: 'Ambientes',
        icon: 'home',
        class: '',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/arbitros',
        title: 'Arbitros',
        moduleName: 'Arbitros',
        icon: 'users',
        class: '',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
      {
        path: '/dashboard/requisitos',
        title: 'Requisitos',
        moduleName: 'requisitos',
        icon: 'users',
        class: '',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
    ],
    roles: ['admin']
  },
  {
    path: '/dashboard/jugadores',
    title: 'Jugadores',
    moduleName: 'jugadores-admin',
    icon: 'box',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['admin', 'planillero']
  },
  {
    path: '/dashboard/torneo/list-torneo',
    title: 'Torneos',
    moduleName: 'torneo',
    icon: 'award',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['admin']
  },
  // {
  //   path: '/dashboard/club/mi-club/club-inicio',
  //   title: 'Mi-Club',
  //   moduleName: 'club',
  //   icon: 'users',
  //   class: '',
  //   groupTitle: false,
  //   submenu: [],
  //   roles: ['delegado']
  // },
  {
    path: '/dashboard/jugador/list-jugador',
    title: 'Jugadores',
    moduleName: 'Jugador',
    icon: 'users',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['delegado']
  },
  {

    path: '/dashboard/directiva/list-directiva',
    title: 'Directiva',
    moduleName: 'Directiva',
    icon: 'box',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['delegado']
  },
  {

    path: '/dashboard/equipo/list-equipo',
    title: 'Equipo',
    moduleName: 'Equipo',
    icon: 'users',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['delegado']
  },

  {
    path: '/dashboard/club',
    title: 'Club',
    moduleName: 'club',
    icon: 'box',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['admin']
  },
  {
    path: '/dashboard/pases',
    title: 'Pases',
    moduleName: 'pases',
    icon: 'box',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['admin']
  },
  {
    path: '/dashboard/planilla',
    title: 'Planilla',
    moduleName: 'planilla',
    icon: 'file-text',
    class: '',
    groupTitle: false,
    submenu: [],
    roles: ['admin','planillero']
  },
  {
    path: '',
    title: 'Reportes',
    moduleName: 'apps',
    icon: 'command',
    class: 'menu-toggle',
    groupTitle: false,
    roles:['admin'],
    submenu: [
      {
        path: '/dashboard/reportes/jugadores',
        title: 'Jugadores',
        moduleName: 'reportes',
        icon: '',
        class: 'ml-menu',
        groupTitle: false,
        submenu: [],
        roles: ['admin']
      },
    ]
  },
  // {
  //   path: '',
  //   title: '-- Principal',
  //   moduleName: '',
  //   icon: '',
  //   class: 'header',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Casa',
  //   moduleName: 'dashboard',
  //   icon: 'monitor',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/dashboard/main',
  //       title: 'Tablero 1',
  //       moduleName: 'dashboard',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/dashboard/dashboard2',
  //       title: 'Tablero 2',
  //       moduleName: 'dashboard',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/dashboard/dashboard3',
  //       title: 'Tablero 3',
  //       moduleName: 'dashboard',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //   ]
  // },

  // {
  //   path: 'advance-table',
  //   title: 'Tabla de anazada',
  //   moduleName: 'advance-table',
  //   icon: 'trello',
  //   class: '',
  //   groupTitle: false,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: '-- Aplicaciones',
  //   moduleName: '',
  //   icon: '',
  //   class: '',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: 'calendar',
  //   title: 'Calendario',
  //   moduleName: 'calendar',
  //   icon: 'calendar',
  //   class: '',
  //   groupTitle: false,
  //   submenu: []
  // },
  // {
  //   path: 'task',
  //   title: 'Tarea',
  //   moduleName: 'task',
  //   icon: 'check-box',
  //   class: '',
  //   groupTitle: false,
  //   submenu: []
  // },
  // {
  //   path: 'contacts',
  //   title: 'Contactos',
  //   moduleName: 'contacts',
  //   icon: 'users',
  //   class: '',
  //   groupTitle: false,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Email',
  //   moduleName: 'email',
  //   icon: 'mail',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/email/inbox',
  //       title: 'Bandeja de entrada',
  //       moduleName: 'email',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/email/compose',
  //       title: 'Componer',
  //       moduleName: 'email',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/email/read-mail',
  //       title: 'Leer el correo electrónico',
  //       moduleName: 'email',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Más aplicaciones',
  //   moduleName: 'apps',
  //   icon: 'command',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/apps/chat',
  //       title: 'Lista de chat',
  //       moduleName: 'apps',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/dragdrop',
  //       title: 'Arrastrar y soltar basico',
  //       moduleName: 'apps',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/contact-grid',
  //       title: 'Cuadricula de contacto',
  //       moduleName: 'apps',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/support',
  //       title: 'Tickets de soporte',
  //       moduleName: 'apps',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: '-- Componentes',
  //   moduleName: '',
  //   icon: '',
  //   class: 'header',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Widgets',
  //   moduleName: 'widget',
  //   icon: 'briefcase',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/widget/chart-widget',
  //       title: 'Widgets graficos',
  //       moduleName: 'widget',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/widget/data-widget',
  //       title: 'Widgets de datos',
  //       moduleName: 'widget',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Formularios',
  //   moduleName: 'forms',
  //   icon: 'layout',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/forms/form-controls',
  //       title: 'Controles de formulario',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/advance-controls',
  //       title: 'Control avanzado',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/form-example',
  //       title: 'Ejemplos de formularios',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/form-validation',
  //       title: 'Validación de formulario',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/wizard',
  //       title: 'Steppers',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/editors',
  //       title: 'Editores',
  //       moduleName: 'forms',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Tablas',
  //   moduleName: 'tables',
  //   icon: 'grid',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/tables/basic-tables',
  //       title: 'Tablas básicas',
  //       moduleName: 'tables',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/tables/material-tables',
  //       title: 'Tablas de material',
  //       moduleName: 'tables',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/tables/ngx-datatable',
  //       title: 'NGX-Datatable',
  //       moduleName: 'tables',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Charts',
  //   moduleName: 'charts',
  //   icon: 'pie-chart',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/charts/echart',
  //       title: 'Echart',
  //       moduleName: 'charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/apex',
  //       title: 'Apex',
  //       moduleName: 'charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/chartjs',
  //       title: 'ChartJS',
  //       moduleName: 'charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/ngx-charts',
  //       title: 'Ngx-Charts',
  //       moduleName: 'charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/gauge',
  //       title: 'Gauge',
  //       moduleName: 'charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'User Interface (UI)',
  //   moduleName: 'ui',
  //   icon: 'copy',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/ui/alerts',
  //       title: 'Alerts',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/badges',
  //       title: 'Badges',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/chips',
  //       title: 'Chips',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/modal',
  //       title: 'Modal',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/buttons',
  //       title: 'Buttons',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/expansion-panel',
  //       title: 'Expansion Panel',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/bottom-sheet',
  //       title: 'Bottom Sheet',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/dialogs',
  //       title: 'Dialogs',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/cards',
  //       title: 'Cards',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/labels',
  //       title: 'Labels',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/list-group',
  //       title: 'List Group',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/snackbar',
  //       title: 'Snackbar',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/preloaders',
  //       title: 'Preloaders',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/progressbars',
  //       title: 'Progress Bars',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/tabs',
  //       title: 'Tabs',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/typography',
  //       title: 'Typography',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/helper-classes',
  //       title: 'Helper Classes',
  //       moduleName: 'ui',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Icons',
  //   moduleName: 'icons',
  //   icon: 'feather',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/icons/material',
  //       title: 'Material Icons',
  //       moduleName: 'icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/font-awesome',
  //       title: 'Font Awesome',
  //       moduleName: 'icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/simple-line',
  //       title: 'Simple Line Icons',
  //       moduleName: 'icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/themify',
  //       title: 'Themify Icons',
  //       moduleName: 'icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Maps',
  //   moduleName: 'maps',
  //   icon: 'map-pin',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/maps/google',
  //       title: 'Google Map',
  //       moduleName: 'maps',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: '-- Extra',
  //   moduleName: '',
  //   icon: '',
  //   class: 'header',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Timeline',
  //   moduleName: 'timeline',
  //   icon: 'git-pull-request',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/timeline/timeline1',
  //       title: 'Timeline 1',
  //       moduleName: 'timeline',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/timeline/timeline2',
  //       title: 'Timeline 2',
  //       moduleName: 'timeline',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Medias',
  //   moduleName: 'media',
  //   icon: 'image',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/media/gallery',
  //       title: 'Image Gallery',
  //       moduleName: 'media',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Authentication',
  //   moduleName: 'authentication',
  //   icon: 'user-check',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/authentication/signin',
  //       title: 'Sign In',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/signup',
  //       title: 'Sign Up',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/forgot-password',
  //       title: 'Forgot Password',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/locked',
  //       title: 'Locked',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/page404',
  //       title: '404 - Not Found',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/page500',
  //       title: '500 - Server Error',
  //       moduleName: 'authentication',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Extra Pages',
  //   moduleName: 'extra-pages',
  //   icon: 'anchor',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/extra-pages/profile',
  //       title: 'Profile',
  //       moduleName: 'extra-pages',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/pricing',
  //       title: 'Pricing',
  //       moduleName: 'extra-pages',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/invoice',
  //       title: 'Invoice',
  //       moduleName: 'extra-pages',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/faqs',
  //       title: 'Faqs',
  //       moduleName: 'extra-pages',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/blank',
  //       title: 'Blank Page',
  //       moduleName: 'extra-pages',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Multi level Menu',
  //   moduleName: 'multilevel',
  //   icon: 'chevrons-down',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/multilevel/first1',
  //       title: 'First',
  //       moduleName: 'multilevel',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/',
  //       title: 'Second',
  //       moduleName: 'secondlevel',
  //       icon: '',
  //       class: 'ml-sub-menu',
  //       groupTitle: false,
  //       submenu: [
  //         {
  //           path: '/multilevel/secondlevel/second1',
  //           title: 'Second 1',
  //           moduleName: 'secondlevel',
  //           icon: '',
  //           class: 'ml-sub-sub-menu',
  //           groupTitle: false,
  //           submenu: []
  //         },
  //         {
  //           path: '/multilevel/secondlevel/second2',
  //           title: 'Second 2',
  //           moduleName: 'secondlevel',
  //           icon: '',
  //           class: 'ml-sub-sub-menu',
  //           groupTitle: false,
  //           submenu: []
  //         }
  //       ]
  //     },
  //     {
  //       path: '/multilevel/first3',
  //       title: 'Third',
  //       moduleName: 'multilevel',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // }
];
